let pending = null

export function setPendingAnchor(name) {
  pending = name
}

export function peekPendingAnchor() {
  return pending
}

export function consumePendingAnchor() {
  const v = pending
  pending = null
  return v
}
